export function useFormatDate() {
  const formatHumanDatetime = (value) => {
    const date = new Date(value);
    return `${date.toLocaleDateString('en-GB')} ${date.toLocaleTimeString('en-GB', {
      timeStyle: 'short',
    })}`;
  };

  const formatHumanDate = (value) => {
    const date = new Date(value);
    return date.toLocaleDateString('en-GB');
  };

  return { formatHumanDatetime, formatHumanDate };
}
